/*  ==========================================================================
    LINKBOXESV2
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import 'jquery-inview';
import objectFitImages from 'object-fit-images';

// local imports
/*
 * MODULE
 */

export function initLinkBoxesV2($element) {

    let images = $element.find('img');
    objectFitImages(images, {
        watchMQ: true
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/linkboxes_v2.js